(function () {
  if (window.__prBaseInit) return;
  window.__prBaseInit = true;

  // Mark JS as ready so reveal styles apply only when JS can animate them.
  document.documentElement.classList.add('pr-js');

  function revealAll() {
    document.querySelectorAll('.pr-reveal:not(.is-visible)').forEach(function (e) {
      e.classList.add('is-visible');
    });
  }

  function reveal(root) {
    var scope = root || document;
    var els = scope.querySelectorAll('.pr-reveal:not(.is-visible)');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (e) { e.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) {
          en.target.classList.add('is-visible');
          io.unobserve(en.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  if (document.readyState !== 'loading') {
    reveal();
  } else {
    document.addEventListener('DOMContentLoaded', function () { reveal(); });
  }

  document.addEventListener('shopify:section:load', function (e) { reveal(e.target); });

  // Safety net: never leave content hidden if the observer fails to fire.
  window.setTimeout(revealAll, 1400);
  window.addEventListener('load', function () { window.setTimeout(revealAll, 300); });

  window.prReveal = reveal;
})();
